import { useState, useEffect } from "react";
import { Row, Col, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Button } from "../../components/core/basic/Button";
import FormGroupTile from "../../components/core/basic/FormGroupTile";

export const RemoveCompetitor = ({ deleteCompetitor, id, setShowRemoveCompetitor, showRemoveCompetitor }) => {
  const { t } = useTranslation(["pricingv2", "common"]);
  const hideModal = () => {
    setShowRemoveCompetitor(false);
  };

  return (
    <Modal show={showRemoveCompetitor} onHide={() => hideModal()} size="xm">
      <Modal.Header closeButton className="py-0 px-5">
        <div className="fs-3 my-4 text-center">{t(($) => $.pricingv2["Add a new competitor"])}</div>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col>
            <div className="fs-4 pb-4 text-center">
              {t(($) => $.pricingv2["Are you sure you want to remove this competitor?"])}
            </div>
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Row className="py-4" style={{ width: "100%" }}>
          <Col xs={3} className="mx-auto text-start"></Col>
          <Col xs={4} className="mx-auto text-start">
            <Button onPress={() => hideModal()}>{t(($) => $.common.actions.Close)}</Button>
          </Col>

          <Col xs={5} className="mx-auto text-end">
            <Button
              onPress={() => {
                deleteCompetitor(id);
              }}
            >
              {t(($) => $.pricingv2["Remove"])}
            </Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
};

const AddCompetitor = ({ productId, createCompetitor, setShowAddCompetitor, showAddCompetitor }) => {
  const { t } = useTranslation(["pricingv2", "common"]);
  const [url, setUrl] = useState("");
  const [adding, setAdding] = useState(false);

  useEffect(() => {
    setUrl("");
    setAdding(false);
  }, [showAddCompetitor]);

  const addCompetitorClick = async () => {
    createCompetitor(productId, url);
    setAdding(true);
  };

  const hideModal = () => {
    setShowAddCompetitor(false);
  };

  return (
    <Modal show={showAddCompetitor} onHide={() => hideModal()} size="xm">
      <Modal.Header closeButton={!adding} className="py-0 px-5">
        <div className="fs-3 my-4 text-center">{t(($) => $.pricingv2["Add a new competitor"])}</div>
      </Modal.Header>
      <Modal.Body>
        <Row>
          <Col>
            <div className="fs-4 pb-4 text-center">
              {t(($) => $.pricingv2["Enter the Amazon URL of the product you want to add as a competitor"])}
            </div>
            <div className="fs-4 pb-4 text-left">
              <FormGroupTile
                type="formcontrol"
                prefixSide={"left"}
                formControlType={"text"}
                handleChildFormElement={(key, value) => {
                  setUrl(value);
                }}
                formControlClass="text-start"
                onKeyUp={(e) => {
                  if (e.key === "Enter") {
                    setAdding(true);
                    addCompetitorClick();
                  }
                }}
                placeholder={`https://www.amazon.com/dp/COMPETITOR-ASIN`}
                defaultValue={url}
              />
            </div>

            {adding && (
              <div className="fs-4 py-4 text-center">
                {t(($) => $.pricingv2["The competitive product is being added. This may take a few seconds."])}
              </div>
            )}
          </Col>
        </Row>
      </Modal.Body>
      <Modal.Footer>
        <Row className="py-4" style={{ width: "100%" }}>
          <Col xs={6} className="mx-auto text-start">
            <Button onPress={() => hideModal()} isDisabled={adding}>
              {t(($) => $.common.actions.Close)}
            </Button>
          </Col>

          <Col xs={6} className="mx-auto text-end">
            <Button
              onPress={() => {
                setAdding(true);
                addCompetitorClick();
              }}
              isDisabled={adding}
            >
              {t(($) => $.pricingv2["Add"])}
            </Button>
          </Col>
        </Row>
      </Modal.Footer>
    </Modal>
  );
};

export default AddCompetitor;
